/* eslint-disable */
import { Project, ProjectFile } from '../index';

declare var Object: any;
export interface ProjectExternalScriptInterface {
  id?: string;
  title?: string;
  content?: string;
  location?: string;
  sourceType: string;
  type: string;
  projectId?: string;
  projectFileId?: string;
  createdDate?: Date;
  createdBy?: string;
  createdById?: string;
  updatedDate?: Date;
  updatedBy?: string;
  updatedById?: string;
  project?: Project;
  projectFile?: ProjectFile;
}

export class ProjectExternalScript implements ProjectExternalScriptInterface {
  'id'?: string;
  'title': string;
  'content': string;
  'sourceType': string;
  'location': string;
  'type': string;
  'projectId': string;
  'projectFileId': string;
  'createdDate': Date;
  'createdBy': string;
  'createdById': string;
  'updatedDate': Date;
  'updatedBy': string;
  'updatedById': string;
  project: Project;
  projectFile: ProjectFile;
  constructor(data?: ProjectExternalScriptInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ProjectExternalScript`.
   */
  public static getModelName() {
    return 'ProjectExternalScript';
  }
  /**
   * @method factory
   * @author Jonathan Casarrubias
   * @license MIT
   * This method creates an instance of ProjectExternalScript for dynamic purposes.
   **/
  public static factory(
    data: ProjectExternalScriptInterface
  ): ProjectExternalScript {
    return new ProjectExternalScript(data);
  }
  /**
   * @method getModelDefinition
   * @author Julien Ledun
   * @license MIT
   * This method returns an object that represents some of the model
   * definitions.
   **/
  public static getModelDefinition() {
    return {
      name: 'ProjectExternalScript',
      plural: 'ProjectExternalScripts',
      path: 'project-external-scripts',
      idName: 'id',
      properties: {
        id: {
          name: 'id',
          type: 'string',
        },
        title: {
          name: 'title',
          type: 'string',
        },
        content: {
          name: 'content',
          type: 'string',
        },
        location: {
          name: 'location',
          type: 'string',
        },
        sourceType: {
          name: 'id',
          type: 'string',
        },
        type: {
          name: 'type',
          type: 'string',
        },
        projectId: {
          name: 'projectId',
          type: 'string',
        },
        projectFileId: {
          name: 'projectFileId',
          type: 'string',
        },
        createdDate: {
          name: 'createdDate',
          type: 'Date',
        },
        createdBy: {
          name: 'createdBy',
          type: 'string',
        },
        createdById: {
          name: 'createdById',
          type: 'string',
        },
        updatedDate: {
          name: 'updatedDate',
          type: 'Date',
        },
        updatedBy: {
          name: 'updatedBy',
          type: 'string',
        },
        updatedById: {
          name: 'updatedById',
          type: 'string',
        },
      },
      relations: {
        project: {
          name: 'project',
          type: 'Project',
          model: 'Project',
          relationType: 'belongsTo',
          keyFrom: 'projectId',
          keyTo: 'id',
        },
        projectFile: {
          name: 'projectFile',
          type: 'ProjectFile',
          model: 'ProjectFile',
          relationType: 'belongsTo',
          keyFrom: 'projectFileId',
          keyTo: 'id',
        },
      },
    };
  }
}
